import { arrayBufferDownloadExcel } from "../../../../utils/download";
import {
  decorateEmptyGridValues,
} from "../../../../utils/table/gridUtils";
import {
  FETCH_AFFILIATE_LIST,
  TOAST,
  FETCH_AFFILIATE_INIT,
  FETCH_AFFILIATE_DETAIL,
  EXPORT_AFFILIATE,
  CREATE_AFFILIATE,
  EDIT_AFFILIATE,
  INIT_CREATE_AFFILIATE_SCREEN,
  AFFILIATE_DD,
  AFFILIATE_SAVE_TABLE_STATE,
  CURRENCY_CODE_DD,
  AFFILIATE_LOCATION_WITH_AFFILIATE_DD,
} from "../../../types/affiliate.type";

const formFieldValueMap = {
  id: null,
  affiliateName: "",
  affiliateCode: "",
  address: "",
  city: "",
  province: "",
  country: "",
  pin: "",
  contactNumber: "",
  email: "",
  gmapLink: "",
  currencyCode: "",
  commissionType: "",
  commissionTypeValue: "",
  status: "",
  locationId: [],
  networkId: [],
  crtTime: "",
  modTime: "",
  modBy: "",
  crtBy: "",
};

const INITIAL_STATE = {
  affiliateListview: [],
  affiliateDD: [],
  isAffiliateDDSuccess: false,
  isAffiliateDDError: false,
  isLoading: false,
  error: null,
  formFieldValueMap,
  isCreateSuccess: false,
  isCreateError: false,
  isDetailSuccess: false,
  isDetailError: false,
  isEditSuccess: false,
  isEditError: false,
  isAffiliateExportSuccess: false,
  isAffiliateExportError: false,
  savedTableState: null,
  isSendingInvitations: false,
  isSendInvitationsSuccess: false,
  isSendInvitationsError: false,
  sendInvitationsErrorMessage: null,
  currencyCodeDD: [],
  affiliateLocationWithAffiliateDD: [],
};

const transformToGridView = (data) => {
  const rows = data.map((item) => {
    const {
      id,
      affiliateName,
      affiliateCode,
      address,
      city,
      province,
      country,
      contactNumber,
      email,
      currencyCode,
      status,
      crtBy,
      crtTime,
      modBy,
      modTime,
      locations,
      networks,
    } = item;

    const transformedValues = {
      id,
      affiliateId: id,
      affiliateName,
      affiliateCode,
      address,
      city,
      province,
      country,
      contactNumber,
      email,
      currencyCode,
      status: status === "Active" || status === true || status === 1 ? "Active" : "Inactive",
      locations,
      networks,
      crtBy,
      crtTime,
      modBy,
      modTime,
    };

    const decoratedValues = {};
    Object.keys(transformedValues).forEach((key) => {
      decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
    });
    return decoratedValues;
  });

  const columns = [
    {
      colLabel: "Affiliate ID",
      dataKey: "affiliateId",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: true,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Affiliate Code",
      dataKey: "affiliateCode",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Affiliate Name",
      dataKey: "affiliateName",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Email",
      dataKey: "email",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Contact Number",
      dataKey: "contactNumber",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Address",
      dataKey: "address",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "City",
      dataKey: "city",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Province",
      dataKey: "province",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Country",
      dataKey: "country",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Currency Code",
      dataKey: "currencyCode",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Locations",
      dataKey: "locations",
      extraProps: {
        isSortable: false,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Networks",
      dataKey: "networks",
      extraProps: {
        isSortable: false,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Status",
      dataKey: "status",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Created By",
      dataKey: "crtBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Created Time",
      dataKey: "crtTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Modified By",
      dataKey: "modBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Modified Time",
      dataKey: "modTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
  ];

  return {
    datas: { columns, rows },
  };
};

export const affiliateReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_AFFILIATE_INIT:
      return {
        ...INITIAL_STATE,
        savedTableState: state.savedTableState,
        isLoadingPage: true,
      };

    case FETCH_AFFILIATE_DETAIL.START:
      return { ...state, isLoading: true, isDetailSuccess: false };

    case EXPORT_AFFILIATE.START:
    case FETCH_AFFILIATE_LIST.START:
    case CREATE_AFFILIATE.START:
    case AFFILIATE_DD.START:
    case EDIT_AFFILIATE.START:
    case CURRENCY_CODE_DD.START:
      return { ...state, isLoading: true };

    case FETCH_AFFILIATE_LIST.SUCCESS: {
      const { page, data } = action.payload;

      let resetState = {
        affiliateListview: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        isCreateSuccess: false,
        isCreateError: false,
        savedTableState: state.savedTableState,
      };

      if (!data) {
        return resetState;
      }

      const { number, size, totalElements, totalPages } = page;
      const { datas } = transformToGridView(data);

      return {
        ...resetState,
        affiliateListview: datas,
        paginationInfo: {
          pageSize: size,
          totalRecords: totalElements,
          totalPages: totalPages,
          pageNumber: number,
        },
      };
    }

    case FETCH_AFFILIATE_LIST.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        affiliateListview: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
        isDeletionSuccess: false,
        isDeletionError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }

    case FETCH_AFFILIATE_DETAIL.SUCCESS: {
      const temp = { ...action.payload };

      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
            if (key === "status") {
              const statusVal = action.payload[key];
              if (statusVal === true || statusVal === 1 || statusVal === "Active") {
                temp[key] = 1;
              } else {
                temp[key] = 0;
              }
            } else if (key === "locationId" || key === "networkId") {
              temp[key] = Array.isArray(action.payload[key]) ? action.payload[key] : [];
            } else {
              temp[key] = action.payload[key];
            }
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isDetailSuccess: true,
      };
    }

    case FETCH_AFFILIATE_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isDetailSuccess: false,
        isDetailError: true,
      };
    }

    case EXPORT_AFFILIATE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isAffiliateExportSuccess: false,
        isAffiliateExportError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case EXPORT_AFFILIATE.SUCCESS: {
      const data = action.payload;
      arrayBufferDownloadExcel(data, "affiliate.xls");
      return {
        ...state,
        isAffiliateExportSuccess: true,
        isAffiliateExportError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case EDIT_AFFILIATE.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isEditSuccess: false,
        isEditError: true,
      };
    }

    case EDIT_AFFILIATE.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isEditSuccess: true,
        isEditError: false,
      };
    }

    case AFFILIATE_DD.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        affiliateDD: temp,
        isAffiliateDDSuccess: true,
        isAffiliateDDError: false,
      };
    }

    case AFFILIATE_DD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isAffiliateDDSuccess: false,
        isAffiliateDDError: true,
      };
    }

    case INIT_CREATE_AFFILIATE_SCREEN: {
      return { ...INITIAL_STATE, savedTableState: state.savedTableState };
    }

    case CREATE_AFFILIATE.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isCreateSuccess: false,
        isCreateError: true,
      };
    }

    case CREATE_AFFILIATE.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isCreateSuccess: true,
        isCreateError: false,
      };
    }

    case TOAST.RESET: {
      return {
        ...state,
        isCreateSuccess: false,
        isCreateError: false,
        isEditError: false,
        isEditSuccess: false,
        isDetailError: false,
        isSendInvitationsSuccess: false,
        isSendInvitationsError: false,
      };
    }

    case AFFILIATE_SAVE_TABLE_STATE: {
      return {
        ...state,
        savedTableState: action.payload,
      };
    }

    case "SEND_AFFILIATE_INVITATIONS_START": {
      return {
        ...state,
        isSendingInvitations: true,
        isSendInvitationsSuccess: false,
        isSendInvitationsError: false,
        sendInvitationsErrorMessage: null,
      };
    }

    case "SEND_AFFILIATE_INVITATIONS_SUCCESS": {
      return {
        ...state,
        isSendingInvitations: false,
        isSendInvitationsSuccess: true,
        isSendInvitationsError: false,
        sendInvitationsErrorMessage: null,
      };
    }

    case "SEND_AFFILIATE_INVITATIONS_ERROR": {
      const { error } = action.payload;
      return {
        ...state,
        isSendingInvitations: false,
        isSendInvitationsSuccess: false,
        isSendInvitationsError: true,
        sendInvitationsErrorMessage: error?.message || "Failed to send invitations",
      };
    }

    case CURRENCY_CODE_DD.SUCCESS:
      return {
        ...state,
        isLoading: false,
        currencyCodeDD: action.payload || [],
      };

    case CURRENCY_CODE_DD.ERROR:
      return {
        ...state,
        isLoading: false,
        currencyCodeDD: [],
      };

    case AFFILIATE_LOCATION_WITH_AFFILIATE_DD.START:
      return { ...state, isLoading: true };

    case AFFILIATE_LOCATION_WITH_AFFILIATE_DD.SUCCESS:
      return {
        ...state,
        isLoading: false,
        affiliateLocationWithAffiliateDD: action.payload || [],
      };

    case AFFILIATE_LOCATION_WITH_AFFILIATE_DD.ERROR:
      return {
        ...state,
        isLoading: false,
        affiliateLocationWithAffiliateDD: [],
      };

    default:
      return state;
  }
};
